import { lazy, LazyExoticComponent, ComponentType } from 'react';
import type { ShopOut } from 'openapi-client';

export interface PageModels {
	shop: ShopOut;
	checkout: ShopOut;
}

export interface PageRegistryEntry<T> {
	component: LazyExoticComponent<ComponentType<{ model: T }>>;
	getModel: (initialData: T) => T;
}

export const pageRegistry: {
	[K in keyof PageModels]: PageRegistryEntry<PageModels[K]>;
} = {
	shop: {
		component: lazy(() => import('./shop/shop')),
		getModel: (initialData) => initialData,
	},
	checkout: {
		component: lazy(() => import('./checkout/checkout')),
		getModel: (initialData) => initialData,
	},
};
